import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { CDN_TYPE_CMS, imageUrlCDN } from 'utils';

import { SiteConfigManager } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';

const BlogCard = ({ id, imageUrl, title }) => {
  const blogPath = SiteConfigManager.getComponentPath(COMPONENT_TYPES.BLOG);

  return (
    <Link aria-label="blog" className="blog-card" to={`${blogPath}/${id}`}>
      <div className="blog-card__img-wrapper">
        <img
          alt={title}
          className="blog-card__img"
          loading="lazy"
          src={imageUrlCDN(imageUrl, CDN_TYPE_CMS)}
        />
      </div>

      <div className="blog-card__wrapper">
        <h2 className="blog-card__text">{title}</h2>
      </div>
    </Link>
  );
};

BlogCard.propTypes = {
  id: PropTypes.number.isRequired,
  imageUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default BlogCard;
